/**
 * @generated SignedSource<<7b686725359e6473097e7aaa93b5bcda>>
 * @relayHash d81b863e337bab456d5583fcb5186c7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ViewSettingsDataResolverQuery } from './ViewSettingsDataResolverQuery.graphql';

const node: PreloadableConcreteRequest<ViewSettingsDataResolverQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54",
    "metadata": {},
    "name": "ViewSettingsDataResolverQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
